"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldDocumentElement = void 0;
const react_1 = __importStar(require("react"));
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const doshx_controls_web_1 = require("doshx_controls_web");
const document_1 = require("../../../../../../reducers/slices/document/document");
const react_redux_1 = require("react-redux");
const constants_1 = require("../../../../../../constants/constants");
const ui_1 = require("../../../../../../reducers/slices/ui");
const lock_user_1 = __importDefault(require("../lock_user"));
const main_1 = require("../../../../../../reducers/slices/main");
const useSearchDebounce_1 = require("../../../../../../hooks/useSearchDebounce");
const update_single_element_thunk_1 = require("../../../../../../reducers/slices/document/thunks/update/update_single_element_thunk");
const react_2 = require("@heroui/react");
const testHelpers_1 = require("../../../../../../helpers/testHelpers");
const type = "TextField";
// Note: Scaling is handled by PreviewDocumentElementWrapper - this component renders at 100%
exports.TextFieldDocumentElement = {
    type,
    sideBarComponent: SideBarComponent,
    documentComponent: DocumentComponent,
    propertiesComponent: OverLayComponent,
    construct: (_id, page) => {
        return {
            _id,
            type,
            page,
            // Explicit dimensions match what HeroUI Input renders at (~48-50px tall
            // for variant="flat" with floating label). Used by the drag overlay,
            // wrapper, and PDF labelledBox so all three surfaces agree on size.
            width: 200,
            height: 50,
            extra_attributes: {
                value: "",
                user: null,
                label: "",
                lockUser: null,
                helperText: "Helper text",
                required: false,
                placeholder: "placeHolder",
                edit_type: "fillable",
                x: 0,
                y: 0,
            },
        };
    },
    sidebarBtnElement: {
        icon: pro_light_svg_icons_1.faInputText,
        label: "Text",
    },
};
function DocumentComponent({ elementInstance }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocument, documentErrors, selectedDocumentElements, documentState } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { user, accessAuth } = (0, react_redux_1.useSelector)((state) => state.userState);
    const { loginAuthenticated } = (0, react_redux_1.useSelector)((state) => state.uiState);
    //const [value, setValue] = useState(elementInstance.extra_attributes?.value);
    const [value, setValue] = (0, useSearchDebounce_1.useSearchDebounce)();
    const stateCheck = documentState === constants_1.TYPE_LINK;
    const isDraftMode = documentState !== constants_1.TYPE_LINK;
    const _element = (_a = selectedDocumentElements.find((x) => x._id === elementInstance._id)) !== null && _a !== void 0 ? _a : elementInstance;
    // Field is editable if: no user assigned OR assigned to current user.
    // Mirrors the wrapper/signature/initials check (preview_document_element_wrapper.tsx,
    // siganture.tsx) — assignment can match by email, accessAuth.user_id (mobile/access
    // link signers), or user._id (logged-in users).
    const assignedEmail = (_c = (_b = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.email;
    const assignedUserId = ((_d = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _d === void 0 ? void 0 : _d.user_id) || ((_f = (_e = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 : _f._id);
    const hasAssignment = !!(assignedEmail || assignedUserId);
    const isCurrentUserByEmail = !!(assignedEmail && (user === null || user === void 0 ? void 0 : user.email) && assignedEmail.toLowerCase() === user.email.toLowerCase());
    const isCurrentUserById = !!(assignedUserId && (((accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.user_id) && String(assignedUserId) === String(accessAuth.user_id)) ||
        ((user === null || user === void 0 ? void 0 : user._id) && String(assignedUserId) === String(user._id))));
    const isUser = isDraftMode || !hasAssignment || isCurrentUserByEmail || isCurrentUserById;
    (0, react_1.useEffect)(() => {
        if (value) {
            let _elem = Object.assign(Object.assign({}, _element), { extra_attributes: Object.assign(Object.assign({}, _element.extra_attributes), { value: value }) });
            dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                data: {
                    document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                    payload: _elem,
                },
            }));
        }
    }, [value]);
    // Document must be in active signing flow (SENT → VIEWED → SIGNING)
    // Allow editing in test mode, with FaceTec authorization, OR with valid access code
    // In draft mode, fields should NOT be editable (only configurable via properties sidesheet)
    const isTestMode = (0, testHelpers_1.isTestModeEnabled)();
    const isInSigningFlow = (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "SENT" || (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "VIEWED" || (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "SIGNING";
    const isEditable = !isDraftMode && isInSigningFlow && (isTestMode || loginAuthenticated || !!accessAuth) && isUser;
    // Scaling is handled by PreviewDocumentElementWrapper - this component renders at 100%
    return (react_1.default.createElement("div", { onClick: (e) => {
            // In draft mode, clicking should select the field for property editing
            if (isDraftMode) {
                e.stopPropagation();
                dispatch((0, document_1.setSelectedElementID)(_element._id));
                dispatch((0, document_1.setSelectedElement)(_element));
                return;
            }
            // Once we can identify the current signer (logged in, access-link, or
            // test mode), check field assignment before prompting for FaceTec —
            // an access-link signer who taps another signer's field should see
            // "Field Not Assigned", not the QR auth screen.
            if ((selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) !== "COMPLETED" && isInSigningFlow) {
                const isMobileUser = (accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type) === constants_1.VIEW_TYPE.MOBILE;
                const canIdentifySigner = loginAuthenticated || !!accessAuth || isTestMode || !!(user === null || user === void 0 ? void 0 : user._id);
                if (canIdentifySigner && !isUser) {
                    e.preventDefault();
                    dispatch((0, main_1.setMessageModal)({
                        title: "Field Not Assigned",
                        messages: ["This field is assigned to another signer. You cannot edit it."],
                    }));
                    return;
                }
                if (!loginAuthenticated && !isTestMode && !isMobileUser) {
                    e.preventDefault();
                    dispatch((0, ui_1.showQrAuth)());
                    return;
                }
            }
            if (!isEditable) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
        }, style: {
            width: "100%",
            opacity: !isEditable ? 0.6 : 1,
            cursor: !isUser ? "not-allowed" : "default",
            userSelect: "none",
            WebkitUserSelect: "none",
        } },
        react_1.default.createElement(react_2.Input, { value: stateCheck ? (_g = _element.extra_attributes) === null || _g === void 0 ? void 0 : _g.value : "", placeholder: (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "COMPLETED" ? undefined : (_h = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _h === void 0 ? void 0 : _h.placeholder, label: (_j = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _j === void 0 ? void 0 : _j.label, variant: "flat", isRequired: (_k = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _k === void 0 ? void 0 : _k.required, isInvalid: documentErrors.includes(_element._id), errorMessage: documentErrors.includes(_element._id) ? "This field is required" : undefined, isReadOnly: !isEditable, classNames: {
                inputWrapper: `bg-transparent shadow-none ${documentErrors.includes(_element._id) ? "border border-error" : ""}`,
                input: "text-base",
            }, onChange: (e) => {
                if (isEditable) {
                    setValue(e.target.value);
                    dispatch((0, document_1.editSelectedDocumentElements)(Object.assign(Object.assign({}, _element), { extra_attributes: Object.assign(Object.assign({}, elementInstance.extra_attributes), { value: e.target.value }) })));
                }
            } })));
}
function OverLayComponent() {
    const dispatch = (0, react_redux_1.useDispatch)();
    return (react_1.default.createElement("span", { onClick: () => { }, className: `flex gap-4` },
        react_1.default.createElement("input", { className: `bg-white border border-superDark  focus:ring-superDark/20 focus:border-superDark p-2 w-full cursor-move`, onChange: (e) => { }, readOnly: true })));
}
function SideBarComponent({ elementInstance }) {
    var _a, _b, _c, _d, _e;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocument, selectedDocumentElements } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const _element = (_a = selectedDocumentElements.find((x) => x._id === elementInstance._id)) !== null && _a !== void 0 ? _a : elementInstance;
    // Initialize with existing values
    const [label, setLabel] = (0, react_1.useState)(((_b = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _b === void 0 ? void 0 : _b.label) || "");
    const [placeHolder, setPlaceHolder] = (0, react_1.useState)(((_c = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _c === void 0 ? void 0 : _c.placeholder) || "");
    const [hasUserEdited, setHasUserEdited] = (0, react_1.useState)(false);
    // Sync state when element changes (switching between fields)
    (0, react_1.useEffect)(() => {
        var _a, _b;
        setLabel(((_a = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _a === void 0 ? void 0 : _a.label) || "");
        setPlaceHolder(((_b = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _b === void 0 ? void 0 : _b.placeholder) || "");
        setHasUserEdited(false);
    }, [_element === null || _element === void 0 ? void 0 : _element._id]);
    // Only save when user has actually edited
    (0, react_1.useEffect)(() => {
        if (!hasUserEdited)
            return;
        const timeoutId = setTimeout(() => {
            dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                data: {
                    document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                    payload: Object.assign(Object.assign({}, _element), { extra_attributes: Object.assign(Object.assign({}, _element.extra_attributes), { label: label, placeholder: placeHolder }) }),
                },
            }));
        }, 300);
        return () => clearTimeout(timeoutId);
    }, [label, placeHolder, hasUserEdited]);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Label", size: "small", value: label, borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => {
                setLabel(e);
                setHasUserEdited(true);
            } }),
        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Placeholder", size: "small", value: placeHolder, borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => {
                setPlaceHolder(e);
                setHasUserEdited(true);
            } }),
        react_1.default.createElement(lock_user_1.default, { userProp: (_e = (_d = _element === null || _element === void 0 ? void 0 : _element.extra_attributes) === null || _d === void 0 ? void 0 : _d.user) !== null && _e !== void 0 ? _e : null, onClick: (user) => {
                dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                    data: {
                        document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                        payload: Object.assign(Object.assign({}, _element), { extra_attributes: Object.assign(Object.assign({}, _element.extra_attributes), { user, user_id: user === null || user === void 0 ? void 0 : user._id, restricted: !!user }) }),
                    },
                }));
            } })));
}
